import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Zap } from 'lucide-react';
export function Method() {
  return <section className="py-24 bg-cream" data-id="element-111">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-112">
        <div className="bg-white rounded-3xl shadow-soft overflow-hidden border border-cream-dark" data-id="element-113">
          <div className="grid md:grid-cols-2" data-id="element-114">
            <div className="p-10 lg:p-14 flex flex-col justify-center" data-id="element-115">
              <FadeIn data-id="element-116">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta-light text-terracotta-hover text-sm font-bold tracking-wide mb-6" data-id="element-117">
                  <Zap size={16} data-id="element-118" />
                  LA SOLUCIÓN
                </div>
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-119">
                  Presentamos el Método <br data-id="element-120" />
                  <span className="text-sage-600" data-id="element-121">"Circuit Breaker"</span>
                  <span className="text-xl text-charcoal-light block mt-2 font-normal" data-id="element-122">
                    (Corta-circuitos)
                  </span>
                </h2>
                <p className="text-charcoal-light leading-relaxed mb-6 text-lg" data-id="element-123">
                  A diferencia de la disciplina tradicional, esta técnica de
                  intervención neurosensorial{' '}
                  <strong data-id="element-124">
                    corta la energía de la crisis en 3 etapas físicas y
                    verbales.
                  </strong>
                </p>
                <p className="text-charcoal-light leading-relaxed text-lg" data-id="element-125">
                  No buscamos educar en medio del berrinche; buscamos{' '}
                  <strong data-id="element-126">apagar el incendio</strong> para que el cerebro de tu
                  hijo (y el tuyo) pueda volver a la calma en tiempo récord.
                </p>
              </FadeIn>
            </div>
            <div className="bg-sage-50 p-10 lg:p-14 flex items-center justify-center relative overflow-hidden" data-id="element-127">
              <div className="absolute inset-0 bg-sage-100/50 rounded-full scale-150 blur-3xl" data-id="element-128"></div>
              <FadeIn delay={0.2} className="relative z-10 w-full max-w-sm" data-id="element-129">
                <div className="aspect-square rounded-full border-8 border-white bg-sage-200 shadow-xl flex items-center justify-center p-8 text-center" data-id="element-130">
                  <div data-id="element-131">
                    <div className="text-5xl mb-4" data-id="element-132">🧠 ⚡️ 🧘‍♀️</div>
                    <p className="font-serif font-bold text-sage-700 text-xl" data-id="element-133">
                      De la crisis
                      <br data-id="element-134" />a la calma
                    </p>
                  </div>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}